module.exports = __webpack_public_path__ + "static/algorand-og-image-028054e95cf8a1a4c9b08c3a680f4e0f.jpg";